module.exports = __webpack_public_path__ + "img/pink-1.21d2aa6f.svg";